/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import $, { contains } from 'jquery';
import Variants from '@shopify/theme-variants';
import { formatMoney } from '@shopify/theme-currency';
import { register } from '@shopify/theme-sections';
import _ from 'lodash';

window.jQuery = $;


const selectors = {
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productImageWrapper: '[data-product-image-wrapper]',
  productFeaturedImage: '[data-product-featured-image]',
  productForm: '[data-product-form]',
  productJson: '[data-product-json]',
  productVariantImagesJson: '[data-product-variant-images-json]',
  productPrice: '[data-product-price]',
  productThumbs: '[data-product-single-thumbnail]',
  quantityInput: '#Quantity',
  singleOptionSelector: '[data-single-option-selector]',
  testimonialsSlider: '.testimonial-slider',
  frequencySelect: '.rc_select__frequency',
  productStockJson: '[data-product-variant-stock]',
};

const keyboardKeys = {
  ENTER: 13,
};

document.addEventListener('DOMContentLoaded', function () {
  initQuantitySwitch();
  initAddToCart();
});

/**
 * Product section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 * @param {string} container - selector for the section container DOM element
 */


  function initQuantitySwitch() {
    $('[data-quantity-increment]').on('click', function () {

      let q = document.querySelector($(this).data('target'));

      q.value++;

      $(q).trigger('change');
    });

    $('[data-quantity-decrement]').on('click', function () {
      let q = document.querySelector($(this).data('target'));
      let min = q.value <= 1 ? 1 : q.value - 1;

      q.value = min;

      $(q).trigger('change');

    });

    $('#Quantity').on('change', function() {
      updatePrice(); 
    });
  }

  function updatePrice() {
    let singelPrice = $(selectors.productPrice).attr( 'data-price' );
    let newPrice = singelPrice * $(selectors.quantityInput).val();

    $(selectors.productPrice).html(formatMoney(newPrice));
  }

  function initAddToCart() {
    $(selectors.productForm).on('submit', (e) => {
      e.preventDefault();

      // Check whether or not we've got a subscription product
      // If we do, we need to send some properties with our post request.
      let formData = {};
      let postData = {};

      $(selectors.productForm).serializeArray().forEach(function (field, index) {
        formData[field.name] = field.value;
      });

      // console.log(formData);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  }

  /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */
  function updateProductPrices(evt) {
    const variant = evt.variant;
    const $comparePrice = $(selectors.comparePrice, this.$container);
    const $compareEls = $comparePrice.add(
      selectors.comparePriceText,
      this.$container,
    );

    let compareAtPrice = document.querySelector(selectors.comparePrice);

    if (compareAtPrice.hasAttribute('trial')) {
      $comparePrice.html(
        formatMoney(variant.compare_at_price, theme.moneyFormat),
      );
      $compareEls.removeClass(cssClasses.hide);
    } else {
      $(selectors.productPrice, this.$container).html(
        formatMoney(variant.price, theme.moneyFormat),
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          formatMoney(variant.compare_at_price, theme.moneyFormat),
        );
        $compareEls.removeClass(cssClasses.hide);
      } else {
        $comparePrice.html('');
        $compareEls.addClass(cssClasses.hide);
      }
    }
  }
